import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock, MessageCircle, CheckCircle, Zap } from 'lucide-react';
export function ContactPage() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    service: '',
    wasteType: '',
    volume: '',
    date: '',
    time: '',
    notes: '',
    consent: false
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (form.consent) setSubmitted(true);
  };
  const serviceOptions = ['House Clearance', 'Office Removals', 'Garden Waste', 'Commercial Waste Collection', 'Overseas Removals', 'Estate Agent Clearance', "Builder's Waste", 'Single Item Pick-Up', 'Other'];
  const volumeOptions = ['1–5 bags', 'Half van load', 'Full van load', '2 van loads', '3+ van loads / lorry'];
  const timeOptions = ['7am–9am', '9am–12pm', '12pm–3pm', '3pm–6pm', '6pm–8pm', 'Flexible'];
  return <div className="pt-16 lg:pt-20" data-id="element-317">
      {/* Hero */}
      <section className="py-16 px-4" style={{
      background: 'linear-gradient(135deg, #1B8F4B 0%, #0F5D2E 100%)'
    }} data-id="element-318">
        <div className="max-w-7xl mx-auto text-center" data-id="element-319">
          <p className="text-green-300 text-sm font-bold uppercase tracking-widest mb-3" data-id="element-320">
            Get in Touch
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-321">
            Contact Us
          </h1>
          <p className="text-green-100 text-lg max-w-2xl mx-auto" data-id="element-322">
            Get a free, no-obligation quote. We reply within 30 minutes.
          </p>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="py-12 px-4 bg-white border-b border-gray-100" data-id="element-323">
        <div className="max-w-7xl mx-auto" data-id="element-324">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-325">
            {[{
            icon: Phone,
            label: 'Phone',
            value: '07405 641227',
            href: 'tel:+447405641227',
            color: '#1B8F4B'
          }, {
            icon: MessageCircle,
            label: 'WhatsApp',
            value: 'Message Us',
            href: 'https://wa.me/447405641227',
            color: '#25D366'
          }, {
            icon: Mail,
            label: 'Email',
            value: 'info@universalgloballogistics.co.uk',
            href: 'mailto:info@universalgloballogistics.co.uk',
            color: '#3B82F6'
          }, {
            icon: Clock,
            label: 'Hours',
            value: 'Mon–Sat 7am–8pm',
            href: null,
            color: '#F59E0B'
          }].map(({
            icon: Icon,
            label,
            value,
            href,
            color
          }) => <div key={label} className="flex items-center gap-4 p-5 rounded-2xl border border-gray-100 hover:shadow-md transition-all duration-300" data-id="element-326">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: `${color}15`
            }} data-id="element-327">
                  <Icon className="w-6 h-6" style={{
                color
              }} data-id="element-328" />
                </div>
                <div data-id="element-329">
                  <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider" data-id="element-330">
                    {label}
                  </p>
                  {href ? <a href={href} className="font-bold text-gray-900 text-sm hover:underline" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-331">
                      {value}
                    </a> : <p className="font-bold text-gray-900 text-sm" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-332">
                      {value}
                    </p>}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Form + Map */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-333">
        <div className="max-w-7xl mx-auto" data-id="element-334">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10" data-id="element-335">
            {/* Form */}
            <div className="lg:col-span-2" data-id="element-336">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-337">
                Get Your Free Quote
              </h2>
              {submitted ? <div className="bg-white rounded-2xl p-12 text-center shadow-sm border border-gray-100" data-id="element-338">
                  <CheckCircle className="w-16 h-16 mx-auto mb-4" style={{
                color: '#1B8F4B'
              }} data-id="element-339" />
                  <h3 className="text-2xl font-bold text-gray-900 mb-2" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-340">
                    Quote Request Sent!
                  </h3>
                  <p className="text-gray-500 mb-2" data-id="element-341">
                    We'll be in touch within 30 minutes.
                  </p>
                  <div className="flex items-center justify-center gap-2 text-sm font-semibold" style={{
                color: '#1B8F4B'
              }} data-id="element-342">
                    <Zap className="w-4 h-4" data-id="element-343" /> We reply within 30 minutes
                  </div>
                </div> : <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 space-y-5" data-id="element-344">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-345">
                    {[{
                  label: 'Name / Business Name',
                  key: 'name',
                  type: 'text',
                  placeholder: 'John Smith'
                }, {
                  label: 'Email Address',
                  key: 'email',
                  type: 'email',
                  placeholder: 'john@example.com'
                }, {
                  label: 'Phone Number',
                  key: 'phone',
                  type: 'tel',
                  placeholder: '07405 641227'
                }, {
                  label: 'Address / Postcode',
                  key: 'address',
                  type: 'text',
                  placeholder: 'E4 7AB, Chingford'
                }].map(({
                  label,
                  key,
                  type,
                  placeholder
                }) => <div key={key} data-id="element-346">
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-347">
                          {label}
                        </label>
                        <input type={type} placeholder={placeholder} value={form[key as keyof typeof form] as string} onChange={e => setForm({
                    ...form,
                    [key]: e.target.value
                  })} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-[#1B8F4B] focus:ring-2 focus:ring-[#1B8F4B]/20 transition-colors text-sm" data-id="element-348" />
                      </div>)}
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-349">
                    <div data-id="element-350">
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-351">
                        Service Type
                      </label>
                      <select value={form.service} onChange={e => setForm({
                    ...form,
                    service: e.target.value
                  })} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-[#1B8F4B] focus:ring-2 focus:ring-[#1B8F4B]/20 transition-colors text-sm bg-white" data-id="element-352">
                        <option value="" data-id="element-353">Select a service...</option>
                        {serviceOptions.map(o => <option key={o} value={o} data-id="element-354">
                            {o}
                          </option>)}
                      </select>
                    </div>
                    <div data-id="element-355">
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-356">
                        Volume Estimate
                      </label>
                      <select value={form.volume} onChange={e => setForm({
                    ...form,
                    volume: e.target.value
                  })} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-[#1B8F4B] focus:ring-2 focus:ring-[#1B8F4B]/20 transition-colors text-sm bg-white" data-id="element-357">
                        <option value="" data-id="element-358">Select volume...</option>
                        {volumeOptions.map(o => <option key={o} value={o} data-id="element-359">
                            {o}
                          </option>)}
                      </select>
                    </div>
                  </div>

                  <div data-id="element-360">
                    <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-361">
                      Waste Type
                    </label>
                    <input type="text" placeholder="e.g. household furniture, garden waste, office equipment..." value={form.wasteType} onChange={e => setForm({
                  ...form,
                  wasteType: e.target.value
                })} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-[#1B8F4B] focus:ring-2 focus:ring-[#1B8F4B]/20 transition-colors text-sm" data-id="element-362" />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-363">
                    <div data-id="element-364">
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-365">
                        Preferred Date
                      </label>
                      <input type="date" value={form.date} onChange={e => setForm({
                    ...form,
                    date: e.target.value
                  })} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-[#1B8F4B] focus:ring-2 focus:ring-[#1B8F4B]/20 transition-colors text-sm" data-id="element-366" />
                    </div>
                    <div data-id="element-367">
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-368">
                        Preferred Time
                      </label>
                      <select value={form.time} onChange={e => setForm({
                    ...form,
                    time: e.target.value
                  })} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-[#1B8F4B] focus:ring-2 focus:ring-[#1B8F4B]/20 transition-colors text-sm bg-white" data-id="element-369">
                        <option value="" data-id="element-370">Select time...</option>
                        {timeOptions.map(o => <option key={o} value={o} data-id="element-371">
                            {o}
                          </option>)}
                      </select>
                    </div>
                  </div>

                  <div data-id="element-372">
                    <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-373">
                      Photos (optional)
                    </label>
                    <div className="w-full px-4 py-6 rounded-xl border-2 border-dashed border-gray-200 text-center text-sm text-gray-400 hover:border-[#1B8F4B] transition-colors cursor-pointer" data-id="element-374">
                      📎 Click to upload photos or drag & drop
                    </div>
                  </div>

                  <div data-id="element-375">
                    <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-376">
                      Additional Notes
                    </label>
                    <textarea rows={3} placeholder="Any other details that would help us quote accurately..." value={form.notes} onChange={e => setForm({
                  ...form,
                  notes: e.target.value
                })} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-[#1B8F4B] focus:ring-2 focus:ring-[#1B8F4B]/20 transition-colors text-sm resize-none" data-id="element-377" />
                  </div>

                  <div className="flex items-start gap-3" data-id="element-378">
                    <input type="checkbox" id="consent" checked={form.consent} onChange={e => setForm({
                  ...form,
                  consent: e.target.checked
                })} className="mt-1 w-4 h-4 rounded accent-[#1B8F4B]" data-id="element-379" />
                    <label htmlFor="consent" className="text-sm text-gray-600" data-id="element-380">
                      I consent to Universal Global Logistics contacting me
                      about my quote request. We'll never share your data with
                      third parties.
                    </label>
                  </div>

                  <button type="submit" className="w-full py-4 rounded-xl font-bold text-white text-lg transition-all duration-200 hover:opacity-90 hover:shadow-lg" style={{
                backgroundColor: '#1B8F4B',
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-381">
                    Get My Quote
                  </button>

                  <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-382">
                    <Zap className="w-4 h-4" style={{
                  color: '#F59E0B'
                }} data-id="element-383" />
                    We reply within 30 minutes
                  </div>
                </form>}
            </div>

            {/* Sidebar */}
            <div className="space-y-6" data-id="element-384">
              {/* Map placeholder */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100" data-id="element-385">
                <div className="h-48 bg-gray-100 flex items-center justify-center" style={{
                backgroundColor: '#E5E7EB'
              }} data-id="element-386">
                  <div className="text-center" data-id="element-387">
                    <MapPin className="w-10 h-10 mx-auto mb-2" style={{
                    color: '#1B8F4B'
                  }} data-id="element-388" />
                    <p className="text-sm font-semibold text-gray-600" data-id="element-389">
                      Chingford, North London
                    </p>
                    <p className="text-xs text-gray-400" data-id="element-390">Google Maps</p>
                  </div>
                </div>
                <div className="p-5" data-id="element-391">
                  <h3 className="font-bold text-gray-900 mb-1" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-392">
                    Our Location
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-393">
                    Based in Chingford, serving all London boroughs and
                    overseas.
                  </p>
                </div>
              </div>

              {/* Hours */}
              <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100" data-id="element-394">
                <h3 className="font-bold text-gray-900 mb-4" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-395">
                  Opening Hours
                </h3>
                <div className="space-y-2" data-id="element-396">
                  {[['Monday', '7:00am – 8:00pm'], ['Tuesday', '7:00am – 8:00pm'], ['Wednesday', '7:00am – 8:00pm'], ['Thursday', '7:00am – 8:00pm'], ['Friday', '7:00am – 8:00pm'], ['Saturday', '7:00am – 8:00pm'], ['Sunday', '8:00am – 6:00pm']].map(([day, hours]) => <div key={day} className="flex justify-between text-sm" data-id="element-397">
                      <span className="text-gray-600" data-id="element-398">{day}</span>
                      <span className="font-semibold text-gray-900" data-id="element-399">
                        {hours}
                      </span>
                    </div>)}
                </div>
              </div>

              {/* Quick contact */}
              <div className="rounded-2xl p-5" style={{
              background: 'linear-gradient(135deg, #1B8F4B 0%, #0F5D2E 100%)'
            }} data-id="element-400">
                <h3 className="font-bold text-white mb-3" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-401">
                  Prefer to call?
                </h3>
                <p className="text-green-100 text-sm mb-4" data-id="element-402">
                  Speak directly with our team — no bots, no hold music.
                </p>
                <a href="tel:+447405641227" className="block text-center py-3 rounded-xl font-bold text-[#1B8F4B] bg-white hover:bg-green-50 transition-colors text-sm" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-403">
                  📞 07405 641227
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}